<template>
  <div class="bb-sort-by">
    <div class="bb-sort-by-text" @click="show = !show">
      {{ sort_by }}
    </div>

    <div v-show="show" class="bb-sort-by-options">
      <div class="bb-sort-by-option" @click="sortBy('All')">All</div>
      <div
        v-for="filter in $root.filters"
        :key="`filter-${filter}`"
        class="bb-sort-by-option"
        @click="sortBy(filter)"
      >
        {{ filter }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      sort_by: "All",
    };
  },
  methods: {
    sortBy(sort_by) {
      this.sort_by = sort_by;
      this.show = false;

      if (sort_by === "All") {
        this.$root.fittings = JSON.parse(
          JSON.stringify(this.$root.all_fittings)
        );
      } else {
        this.$root.fittings = this.$root.all_fittings.filter((fitting) => {
          return fitting.filters.includes(sort_by);
        });
      }
    },
  },
};
</script>

<style lange="less">
.bb-sort-by {
  display: inline-block;
  position: relative;

  text-align: left;
  cursor: pointer;

  border: 1px solid lightgray;
  border-radius: 5px;

  &,
  & > * {
    -webkit-tap-highlight-color: transparent;
  }
}

.bb-sort-by-text {
  padding: 10px;

  &::after {
    content: url('data:image/svg+xml,<svg width="14px" height="14px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" fill="white"/><path d="M17 9.5L12 14.5L7 9.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    display: inline;
  }
}

.bb-sort-by-options {
  width: 150px;
  position: absolute;
  top: -1px;
  left: -1px;
  z-index: 100;
  background-color: white;
  border-radius: 5px;
  border: 1px solid lightgray;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 10px;

  .bb-sort-by-option {
    padding: 10px;

    &:hover {
      background-color: lightgray;
      cursor: pointer;
    }
  }
}
</style>
